import React from 'react'

export default function StockInListFooterStyle() {
  return (
    <React.Fragment>
      <style jsx="true">
      {`
        #stockin-list-footer-container {
          display: flex;
          margin-right: 17px;
        }
        .warehouse-options-container {
          display: flex;
        }
        .warehouse-options-container select {
          margin: auto;
          padding: 5px;
        }
        .warehouse-options-container select option {
          font-size: 1rem;
        }
      `}
      </style>
    </React.Fragment>
  )
}
